import React, { useState } from "react";

// ASSETS

import logoDsu from "assets/svg/LogoDsu.svg";
// STYLES
import {
  HeaderContainer,
  LogoContainer,
  Logo,
  CenterButtonsWrapper,
  RightButtonsWrapper,
  Button,
  LogoText,
} from "./HeaderStyled";

// LIBRARIES
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

// MISC

import { IProps } from "./HeaderModel";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import { appRoutes } from "config/AppRoutesConfig";

// REDUX

import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// COMPONENTS

import CustomText from "components/Atoms/CustomText/CustomText";
import ButtonsBarAtom from "components/Atoms/ButtonsBarAtom/ButtonsBarAtom";

const Header = (props: IProps) => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const titles = [
    {
      id: 0,
      path: appRoutes.about,
      text: t("components.header.about"),
    },
    {
      id: 1,
      path: appRoutes.dsuNumbers,
      text: t("components.header.dsuNumbers"),
    },
    {
      id: 2,
      path: appRoutes.news,
      text: t("components.header.news"),
    },
    {
      id: 3,
      path: appRoutes.legislation,
      text: t("components.header.legislation"),
    },
    {
      id: 4,
      path: appRoutes.dialog,
      text: t("components.header.dialog"),
    },
  ];

  // STATE CONSTANTS
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS

  return (
    <HeaderContainer>
      <LogoContainer onClick={() => navigate("/")} biggerCursor={biggerCursor}>
        <Logo src={logoDsu} alt="logoDsu" />
        <LogoText>{t("components.header.DSU")}</LogoText>
      </LogoContainer>
      <CenterButtonsWrapper>
        {titles.map((title, index) => {
          return (
            <Button
              key={title.id}
              isSelected={title.path === location.pathname}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              onClick={() => navigate(title.path)}
              biggerCursor={biggerCursor}
            >
              <CustomText
                text={title.text}
                type={TextType.H4}
                color={
                  hoveredIndex === index ? COLORS.RaisinBlack : COLORS.Yellow
                }
              />
            </Button>
          );
        })}
      </CenterButtonsWrapper>
      <RightButtonsWrapper>
        <ButtonsBarAtom />
      </RightButtonsWrapper>
    </HeaderContainer>
  );
};

export default Header;
